import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldCheck3"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.25348L12 1.4353L21 5.25348V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.25348ZM16.3105 9.72999L15.23 8.68953L10.9167 13.1688L8.77001 10.9395L7.68953 11.98L10.9167 15.3312L16.3105 9.72999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCheck3;
